import { createElement } from 'react';
import { BaseMenuProps, MenuDesign, useFocusNavigation } from '.';

export const BaseMenu = (props: BaseMenuProps) => {
  const focusNavigation = useFocusNavigation(props);
  return <MenuDesign {...props} {...focusNavigation} />;
};
